import { render, staticRenderFns } from "./admin-component.vue?vue&type=template&id=2daada86"
import script from "./admin-component.vue?vue&type=script&lang=ts"
export * from "./admin-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports